module.exports = __webpack_public_path__ + "assets/chevin-light.20d5f311cd0dd5871108c244a224282b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OP/chevin-light.eot
// module id = 51
// module chunks = 0